import React,{useState,useEffect,useCallback,useRef} from 'react';
import Card from '@material-ui/core/Card';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {Styles} from './Styles';
import Ajax from './Ajax';

interface State {
    words: string,
    list: string[],
    count: number,
    typeId: string,
    password: string,
}

const Dict = ()=> {
    const classes = Styles.base();
    const def:State = {
        words:"",
        list:[],
        count: 0,
        typeId: "5",
        password: "",
    };
    const [values,setValues] = useState(def);
    const [error,setError] = useState();

    const refValues = useRef(values);
    useEffect(() => {
        refValues.current = values;
    }, [values]);

    //const textInput = useRef(null);
    let textInput:any;

    const handleChange = (name: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setValues({ ...refValues.current, [name]: event.target.value });
    };
    const changeType = () => (event: React.ChangeEvent<HTMLInputElement>) => {
        setValues({ ...refValues.current, "typeId": event.target.value });
        getSample(event.target.value);
    };
	const add = ()=>{
        textInput.focus();
        if( values.words==="" ){
            setError("入力されてないよ");
            return;
        }
        const words = values.words;
        setValues({ ...refValues.current, "words": ""});
		Ajax.send("ku/add",{typeId:values.typeId,text:words,password:values.password},(res:any)=>{
			console.log( res );
			if( !res.ok ){
                if( res.reason==="exist" ){
                    setError("すでに登録済みでした");
                }
                if( res.reason==="wrong" ){
                    setError("パスワードが違います");
                }
                if( res.reason==="error" ){
                    setError("なんかのエラーです");
                }
            }
            getSample(refValues.current.typeId);
		});
	}
	const handleSnackbarClose = (event: React.SyntheticEvent | React.MouseEvent)=>{
		setError(null);
    }
    const getSample = useCallback((typeId:string)=>{
		Ajax.send("ku/list",{typeId:typeId},(res:any)=>{
			console.log( res );
			if( res.ok ){
                setValues({...refValues.current,"list":res.list,"count":res.count});
			}
		});
    },[]);
    
    useEffect( ()=>{
        getSample("5");
    },[getSample]);

	let isError = false;
	if( error ){
		isError = true;
	}

	return (
		<div id="guide" className={classes.root} style={{overflow:"auto"}}>
            <FormControl fullWidth={true}>
                <RadioGroup
                    aria-label="type"
                    name="type"
                    value={values.typeId}
                >
                    <FormControlLabel value="5" control={<Radio onChange={changeType()}/>} label="５文字" />
                    <FormControlLabel value="7" control={<Radio onChange={changeType()}/>} label="７文字" />
                </RadioGroup>
            </FormControl>

            <FormControl fullWidth={true}>
                <TextField
                    id="password"
                    label="パスワード"
                    value={values.password}
                    onChange={handleChange('password')}
                    margin="dense"
                    //className={classes.inputXs}
                    variant="outlined"
                    fullWidth
                />
            </FormControl>

            <FormControl fullWidth={true}>
                <TextField
                    id="words"
                    label="語句"
                    value={values.words}
                    onChange={handleChange('words')}
                    margin="dense"
                    //className={classes.inputXs}
                    variant="outlined"
                    autoFocus={true}
                    fullWidth
                    inputRef={(el)=>{textInput=el}}
                />
                <Button variant="contained" color="primary" fullWidth={true} onClick={add}>追加</Button>
            </FormControl>

            {values.list &&
                <Card style={{padding:"1em",marginTop:"1.5em"}}>
                    <div style={{textAlign:"center",marginBottom:"1em",borderBottom:"1px solid silver"}}>
                        {values.count}
                    </div>
                    {values.list.map( (words:string,index:number)=>{
                        const key = "words"+index;
                        return (
                            <div key={key}>{words}</div>
                        )
                    })}
                </Card>
            }

            <Snackbar
                anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
                }}
                open={isError}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                ContentProps={{
                'aria-describedby': 'message-id',
                }}
                message={<span id="message-id">{error}</span>}
                action={[
                <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    className={classes.close}
                    onClick={handleSnackbarClose}
                >
                    <CloseIcon />
                </IconButton>,
                ]}
			/>

    	</div>
	);
}

export default Dict;
